
export function gstHelper({
  finalWeight,
  rate,
  igst,
  cgst,
  sgst,
  taxRate,
  cess,
  taxType, // "GST" | "VAT" | "NONE"
  customerState,
  jewellerState,

  //(optional)
  amount,
  finalRate,
  decimalValue = 3,
  reductionValue = 0,
}) {
  const metalCost = Number((finalWeight * rate).toFixed(2));

  let cgstTax = 0;
  let sgstTax = 0;
  let totalTax = 0;

  const isSameState =
    customerState?.trim().toLowerCase() ===
    jewellerState?.trim().toLowerCase();

  /* TAX CALCULATION */
  switch (taxType) {
    case "VAT": {
      // VAT on metal cost
      const vat = Number(((metalCost * taxRate) / 100).toFixed(2));

      // CESS on VAT
      const cessTax = Number(((vat * cess) / 100).toFixed(2));

      totalTax = vat + cessTax;
      break;
    }

    case "NONE":
      totalTax = 0;
      break;

    case "GST":
    default:
      if (isSameState) {
        // CGST + SGST
        cgstTax = Number(((metalCost * cgst) / 100).toFixed(2));
        sgstTax = Number(((metalCost * sgst) / 100).toFixed(2));

        totalTax = cgstTax + sgstTax;
      } else {
        // IGST
        totalTax = Number(((metalCost * igst) / 100).toFixed(2));
      }
      break;
  }

  const finalAmount = Number((metalCost + totalTax).toFixed(2));
  let grams = 0;

  if (amount && finalRate) {
    console.log("amount--->", amount);
    console.log("finalrate--->", finalRate);
    console.log("decimalvalue--->", decimalValue);
    console.log("reduction--->", reductionValue);

    grams = Number((amount / finalRate).toFixed(decimalValue));
    grams = grams - reductionValue;
    grams = grams > 0 ? grams : 0;
  }

  return {
    metalCost,
    cgst: cgstTax,
    sgst: sgstTax,
    tax: totalTax,
    finalAmount,
    grams,
  };
}
